// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1d20u","title":"card_title__1OgWL","inActive":"card_inActive__6tMtj"};